import {EmpleadoComisionesModel} from './empleado.comisiones.model';

export class ComisionModel {
  _id:string;
  nombre:string;
  empleados:EmpleadoComisionesModel[] = [];
  fechaInicio:string;
  fechaFin:string;
}
